import { API } from '@factorin/container.macro';


export const apiMiddleware = () => next => action => {
    const { state, stateMap } = API;
    const { type, $payload } = action;

    if (stateMap && type in stateMap)
        Object.assign(state, stateMap[type](state, $payload));

    return next(action);
};
